import { useEffect, useState } from 'react';
import { COLUMN_MEDIA } from '../blocks/columns.js';

function readDevice() {
    const bp = document.documentElement.dataset.headerBp;
    if (bp === 'phone' || bp === 'tablet' || bp === 'desktop') return bp;
    if (window.matchMedia(COLUMN_MEDIA.phone).matches) return 'phone';
    if (window.matchMedia(COLUMN_MEDIA.tablet).matches) return 'tablet';
    return 'desktop';
}

/**
 * The device text is laid out for: the one the Appearance preview forces
 * through `html[data-header-bp]`, else the one the window width falls in,
 * by the same widths the columns block and per-device text sizes use.
 * @returns {'desktop'|'tablet'|'phone'}
 */
export default function useTextDevice() {
    const [device, setDevice] = useState('desktop');

    useEffect(() => {
        const read = () => setDevice(readDevice());
        read();
        const observer = new MutationObserver(read);
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-header-bp'],
        });
        window.addEventListener('resize', read);
        return () => {
            observer.disconnect();
            window.removeEventListener('resize', read);
        };
    }, []);

    return device;
}
